<template>
    <div>
        <b-list-group-item class="d-flex align-items-center" v-if="isAdmin || hasAccess">
            <div :style="indent" class="mr-auto" @click="toggleChildren">
                <b-icon v-if="node.directory" :icon="iconClasses"></b-icon>
                <template v-if="node.directory">
                    {{ node.filename }}
                </template>
                <b-link v-if="!node.directory" :href="node.relativePath" target="_blank">
                    {{ node.filename }}
                </b-link>
            </div>
            <small>
                <b-link v-if="node.directory && depth === 0" @click="showFoldersModal(node.filename)"
                        class="h5 text-primary">
                    <b-icon icon="folder-plus"></b-icon>
                </b-link>
                <b-link v-if="node.directory && depth > 0" @click="showUploadModal(node.path)" class="h5 text-primary">
                    <b-icon icon="cloud-upload"></b-icon>
                </b-link>
                <b-link v-if="!node.directory || (node.children && node.children.length === 0)"
                        @click="deleteFile(node.path, (depth === 0 ? node.filename : null) )" class="h5 text-danger ml-3">
                    <b-icon icon="x-circle"></b-icon>
                </b-link>
                <b-icon v-else icon="blank" aria-hidden="true" class="h5 ml-3"></b-icon>
            </small>
        </b-list-group-item>

        <template v-if="showChildren">
            <node-file v-for="(node, index) in node.children" :key="index" :currentIndex="currentIndex + '-' + index"
                       :node="node" :depth="depth + 1" :parentHasAccess="hasAccess"
                       @getClientFolders="getClientFolders"/>
        </template>

        <b-modal :id="uploadModal.id" title="Upload files" @ok="uploadFile" size="lg"
                 ok-title="Upload" :ok-disabled="!uploadModal.files">
            <b-form-file id="upload-files" name="upload-files" multiple required
                         v-model="uploadModal.files"
                         placeholder="Choose a file or drop it here..."
                         drop-placeholder="Drop file here..."/>
        </b-modal>

        <b-modal :id="foldersModal.id" title="Create folder" @ok="createFolder" size="lg" ok-title="Create"
                 :ok-disabled="(!foldersModal.selected || foldersModal.selected.length === 0)
                 && (!foldersModal.portalIds || foldersModal.portalIds.length === 0)">
            <b-row>
                <b-col md="6">
                    <b-form-group label="Folder's name" class="mb-3" disabled>
                        <b-form-input v-model="foldersModal.name"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Subfolders to create">
                        <b-form-checkbox-group
                            v-model="foldersModal.selected"
                            :options="currentSubFolders"
                            name="flavour-2a"
                            stacked
                        ></b-form-checkbox-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Portal Access">
                        <b-overlay :show="loading">
                            <b-form-select v-if="portals" id="portal" name="portal" multiple
                                           v-model="foldersModal.portalIds" required>
                                <b-form-select-option v-for="selectPortal in portals"
                                                      :key="selectPortal.id"
                                                      :value="selectPortal.id">
                                    {{ selectPortal.name }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-overlay>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import FileService from "@/services/FileService";

    export default {
        name: "NodeFile",
        props: {
            node: Object,
            depth: Number,
            currentIndex: String,
            subFolders: Array,
            access: Array,
            parentHasAccess: Boolean,
            portals: Array
        },
        data() {
            return {
                showChildren: false,
                uploadModal: {
                    id: 'modal-upload-field-' + this.currentIndex,
                    rootPath: null,
                    files: []
                },
                hasSubFolders: true,
                currentSubFolders: [],
                foldersModal: {
                    id: 'modal-folders-field-' + this.currentIndex,
                    name: name,
                    selected: [],
                    portalIds: []
                },
                loading: false
            }
        },
        mounted() {
            if (this.subFolders) {
                this.subFolders.forEach(sf => {
                    var valObj = this.node.children.filter(function (elem) {
                        return (sf.value === elem.filename);
                    });
                    var csf = _.cloneDeep(sf)
                    if (valObj.length > 0) {
                        csf.disabled = true
                    } else {
                        this.hasSubFolders = false;
                    }
                    this.currentSubFolders.push(csf);
                })
            }
        },
        computed: {
            iconClasses() {
                return this.showChildren ? 'folder2-open' : 'folder';
            },
            indent() {
                return {transform: `translate(${this.depth * 50}px)`}
            },
            isAdmin() {
                return this.$store.getters.isAdmin;
            },
            hasAccess() {
                if (this.parentHasAccess) {
                    return true;
                }
                var hasAccess = false;
                if (this.depth === 0 && this.access) {
                    this.access.forEach(ac => {
                        if (this.node.filename === ac.name) {
                            hasAccess = true;
                        }
                    });
                }
                return hasAccess;
            }
        },
        methods: {
            toggleChildren() {
                this.showChildren = !this.showChildren;
            },
            showFoldersModal(name) {
                this.loading = true;
                this.foldersModal.name = name;
                this.foldersModal.portalIds = [];
                FileService.getFolderAccessByName(name)
                    .then(response => {
                        this.loading = false;
                        response.data.forEach(ac => {
                            this.foldersModal.portalIds.push(ac.portalId);
                        });
                    })
                    .catch(error => (console.log(error)))
                this.$root.$emit('bv::show::modal', this.foldersModal.id)
            },
            createFolder() {
                this.$bvModal.show('loading-modal');
                if (this.foldersModal.selected && this.foldersModal.selected.length > 0) {
                    FileService.createClientFolders(this.foldersModal.name, this.foldersModal.selected, false)
                        .then(() => {
                            this.getClientFolders();
                            this.$bvModal.hide('loading-modal');
                        })
                        .catch(error => {
                            console.log(error);
                            this.$bvModal.hide('loading-modal');
                        });
                }
                if (this.foldersModal.portalIds && this.foldersModal.portalIds.length > 0) {
                    FileService.updateFolderAccess(this.foldersModal.name, this.foldersModal.portalIds)
                        .then(() => {
                            this.$bvModal.hide('loading-modal');
                        })
                }
            },
            showUploadModal(rootPath) {
                this.uploadModal.rootPath = rootPath;
                this.$root.$emit('bv::show::modal', this.uploadModal.id)
            },
            uploadFile() {
                this.$bvModal.show('loading-modal');
                FileService.uploadFiles(this.uploadModal.rootPath, this.uploadModal.files)
                    .then(response => {
                        console.log(response);
                        this.getClientFolders();
                        this.folderName = '';
                        this.$bvModal.hide('loading-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.$bvModal.hide('loading-modal');
                    });
            },
            deleteFile(path, folderName) {
                this.$bvModal.msgBoxConfirm('Are you sure you want to delete that file/folder ?', {
                    title: 'Please Confirm',
                    okVariant: 'success',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    hideHeaderClose: false,
                })
                    .then(value => {
                        if (value) {
                            this.$bvModal.show('loading-modal');
                            FileService.deleteFile(path, folderName)
                                .then(response => {
                                    console.log(response);
                                    this.getClientFolders();
                                    this.folderName = '';
                                    this.$bvModal.hide('loading-modal');
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.$bvModal.hide('loading-modal');
                                });
                        }
                    })
                    .catch(error => console.log(error));
            },
            getClientFolders: function (data) {
                this.$emit('getClientFolders', data)
            }
        }
    }
</script>

<style scoped>

</style>